<template>
  <div class="home">
    <div class="home-header"></div>
    <div class="home-banner">
      <awesome-swiper name="home-banner" :pagination="false" :turnPages="false" @showLoginHandle="showLoginHandle">
        <swiper-slide>
          <div class="banner-content">
            <div class="banner-content-img">
              <img src="https://master-shopvidi.s3.amazonaws.com/index_images/banner.61fc644.jpg" alt="" class="pc-banner" />
              <img src="https://master-shopvidi.s3.amazonaws.com/index_images/banner_mobile.png" alt="" class="m-banner" />
            </div>
            <div class="banner-content-text">
              <div class="banner-title" v-if="false">TRUSTED BRANDS</div>
              <div class="banner-subtitle">Wholesale like a Big Box</div>
              <div class="banner-ins">Your One-Stop Shop for Wholesale Trendy Unique IPs and Branded Lifestyle Goods</div>
              <div class="banner-button" @click="showLoginHandle" v-if="!login">Sign Up to Shop</div>
            </div>
          </div>
        </swiper-slide>
      </awesome-swiper>
    </div>
    <div class="home-list">
      <div class="home-list-w">
        <div class="list-w-content">
          <div class="w-img">
            <img src="@/assets/img/home/smarter.png" alt="" />
          </div>
          <div class="w-title">Shop smarter.</div>
          <div class="w-ins">
            Discover thousands of trendy IP and branded products directly, and purchase at a great wholesale price
          </div>
        </div>
        <div class="list-w-content">
          <div class="w-img">
            <img src="@/assets/img/home/payments.png" alt="" />
          </div>
          <div class="w-title">Flexible payments.</div>
          <div class="w-ins">
            Buy now, pay later. We offer generous payments methods, such as 60 day payment terms.
            <span class="w-ins-underline" @click="open('/credit-payment')">Check 60 day payment terms</span>
          </div>
        </div>
        <div class="list-w-content">
          <div class="w-img">
            <img src="@/assets/img/home/freeShipping.png" alt="" />
          </div>
          <div class="w-title">No MOQ & Free shipping.</div>
          <div class="w-ins">
            Each opening order has no minimum spend and free shipping, plus the option to reorder at low minimum
          </div>
        </div>
      </div>
    </div>
    <div class="home-store">
      <!-- <div class="home-title">Beauty Store Exlcusive Shelves</div> -->
      <div class="home-title">Gift Shop Exclusive Shelves</div>
      <div class="home-store-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="store"
          :prevName="'store'"
          :nextName="'store'"
        >
          <swiper-slide v-for="(e, i) in storeList" :key="i">
            <div class="store-swiper-list">
              <div class="store-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="store-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>

    <!-- vilocal 专区第一栏目 -->
    <div class="vilocal-zone-main1">
      <div class="banner" v-if="!isMobile">
        <div class="banner-btn" @click="$router.push({name:'vilocal'})">Get free trial sales NOW!</div>
        <img class="vilocal-zone-main1-pc-rules" v-if="false" src="@/assets/img/vilocal/vilocal-rules.png"
              />

      </div>
      <img class="vilocal-zone-main1-m-rules" v-if="false" src="@/assets/img/vilocal/m-rules.png"  />
      <div class="banner-btn-m" v-if="isMobile"  @click="$router.push({name:'vilocal'})">Get free trial sales NOW!</div>
    </div>
    <div class="new-brands">
      <div class="home-title">Most Popular IPs</div>
      <div class="brands-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="store"
          :prevName="'mostPopularBrands'"
          :nextName="'mostPopularBrands'"
        >
          <swiper-slide v-for="(e, i) in mostPopularBrands" :key="i">
            <div class="brands-swiper-list" @click="open(e.url)">
              <div class="brands-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="brands-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>
    <div class="new-brands top-brands">
      <div class="home-title">Shipping from US</div>
      <div class="brands-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="store"
          :prevName="'topbrands1'"
          :nextName="'topbrands1'"
        >
          <swiper-slide v-for="(e, i) in shippingFromUSAList" :key="i">
            <div class="brands-swiper-list" @click="open(e.url)">
              <div class="brands-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="brands-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>
    <div class="new-brands">
      <div class="home-title">New Brands</div>
      <div class="brands-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="store"
          :prevName="'brands'"
          :nextName="'brands'"
        >
          <swiper-slide v-for="(e, i) in brandsList" :key="i">
            <div class="brands-swiper-list" @click="open(e.url)">
              <div class="brands-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="brands-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>


<!--    <div class="home-shopvidi">
      <div class="home-shopvidi-img">
        <img src="@/assets/img/home/shopVidi.png" alt="" class="pc-shopvidi" />
        &lt;!&ndash; <img src="https://master-shopvidi.s3.amazonaws.com/index_images_01.jpg" alt="" class="pc-shopvidi"> &ndash;&gt;
        <img src="https://master-shopvidi.s3.amazonaws.com/index_images/collection_bg_beaty.png" alt="" class="m-shopvidi" />
        &lt;!&ndash; <img src="https://master-shopvidi.s3.amazonaws.com/moblie_banner%402x.png" alt="" class="m-shopvidi"> &ndash;&gt;
      </div>
      <div class="home-shopvidi-text">
        <div>SHOPVIDI BEAUTY TREND</div>
        &lt;!&ndash; <div>Easter Purchasing Rewards On ShopVidi</div> &ndash;&gt;
        <div>Discover the upcoming and trending products that have been top rated and selected by world wide businesses.</div>
        &lt;!&ndash; <div>The First Order Of All Brands For Free Shipping & Get $100 Discount</div> &ndash;&gt;
        <div style="cursor: pointer" @click="open('/category/beauty')">View Collection</div>
        &lt;!&ndash; <div style="cursor: pointer;" @click="open('/collection/featured/easter')">View More</div> &ndash;&gt;
      </div>
    </div>-->

    <div class="home-best-sellers new-brands" v-if="login">
      <div class="home-title">Best Sellers List</div>
      <div class="brands-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="bestStore"
          :prevName="'bestsellers'"
          :nextName="'bestsellers'"
        >
          <swiper-slide v-for="(e, i) in bestSellersList" :key="i">
            <div>
              <CardCom :data="[e]" :type="5" source="home" :isShowBrandTag="true"></CardCom>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>
    <div class="new-brands top-brands" v-if="login">
      <div class="home-title">Top Brands</div>
      <div class="brands-swiper">
        <awesome-swiper
          :pagination="pagination"
          :turnPages="turnPages"
          :swiperData="store"
          :prevName="'topbrands'"
          :nextName="'topbrands'"
        >
          <swiper-slide v-for="(e, i) in topBrandsList" :key="i">
            <div class="brands-swiper-list" @click="open(e.url)">
              <div class="brands-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="brands-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>

    <!-- <div class="new-brands top-brands" >
        <div class="home-title">Most Popular Boutique</div>
        <div class="brands-swiper">
          <awesome-swiper :pagination="pagination" :turnPages="turnPages" :swiperData="store" :prevName="'topbrands2'" :nextName="'topbrands2'">
            <swiper-slide v-for="(e,i) in mostPopularBoutiqueList" :key="i">
              <div class="brands-swiper-list" @click="open(e.url)">
                <div class="brands-swiper-img"><img :src=e.img alt="" :openurl="e.url"></div>
                <div class="brands-swiper-text" :openurl="e.url">
                  {{e.text}}
                </div>
              </div>
            </swiper-slide>
          </awesome-swiper>
        </div>
      </div> -->
    <div class="home-store shop">
      <div class="home-title">Shop by Categories</div>
      <div class="home-store-swiper">
        <awesome-swiper :pagination="false" :turnPages="false" :swiperData="store" :prevName="'shop'" :nextName="'shop'">
          <swiper-slide v-for="(e, i) in shopList" :key="i">
            <div class="store-swiper-list" @click="open(e.url)">
              <div class="store-swiper-img">
                <img :src="e.img" alt="" :openurl="e.url" />
              </div>
              <div class="store-swiper-text" :openurl="e.url">
                {{ e.text }}
              </div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>
    <div class="home-collapse">
      <div class="home-collapse-content">
        <div class="home-collapse-text">
          <div>Your wholesale connection to global brands</div>
          <div>
            Discover the power of ShopVidi, your direct access to global brands. Join us to explore a world of creative, innovative, and fashionable products for your retail business.
          </div>
          <div style="cursor: pointer" @click="open('/about')">Our Story</div>
        </div>
        <div class="home-collapse-components">
          <div class="collapse-components-title">How it works?</div>
          <collapse />
        </div>
      </div>
    </div>
    <!-- 商品评论 -->
    <div class="home-reviews" ref="reviews">
      <h2 class="goods-comments-area">Most Recent Customer Reviews</h2>
      <ReviewsList></ReviewsList>
    </div>
    <div v-if="false" class="home-bottom">
      <div class="home-bottom-swiper">
        <awesome-swiper :pagination="true" :turnPages="false" :swiperData="bottomStore" :prevName="'bottom'" :nextName="'bottom'">
          <swiper-slide v-for="(e, i) in bottomList" :key="i">
            <div class="bottom-swiper-list">
              <div>
                <img :src="e.img" alt="" />
              </div>
              <div>
                {{ e.text }}
              </div>
              <div>{{ e.title }}</div>
            </div>
          </swiper-slide>
        </awesome-swiper>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import awesomeSwiper from './components/awesomeSwiper.vue'
import collapse from './components/collapse.vue'
import ReviewsList from './components/reviewsList.vue'
import homeFooter from './components/homeFooter.vue'
import { swiperSlide } from 'vue-awesome-swiper'
import CardCom from '../components/card.vue'
import { postAction, getAction } from '@/api/manage.js'
import { initWebSocket } from '../../utils/ws'
export default {
  name: 'home',
  components: {
    awesomeSwiper,
    swiperSlide,
    collapse,
    homeFooter,
    CardCom,
    ReviewsList
  },
  data() {
    return {
      bottomStore: {},
      bestStore: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        loopFillGroupWithBlank: true,
        loop: false
      },
      store: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
        loopFillGroupWithBlank: true,
        loop: true
      },
      bottomList: [
        {
          img: require('@/assets/img/home/header_1.png'),
          text: '“ Yes! I LOVE LOVE LOVE the clothing. They are true to size. My customers are going to love them. I’ll do another video tomorrow. I’ll show what I got so everyone can see your logo. ”',
          title: 'By  Retailer, Cassidy Walker'
        },
        {
          img: require('@/assets/img/home/header_2.png'),
          text: '“Everything is great. I actually like it. Shipping was as expected. Communication is good.  The product is great. I like everything I ordered. I like the fact that you dont have a MOQ. ”',
          title: 'By  Retailer, Jerrica Williams'
        },
        {
          img: require('@/assets/img/home/header_3.png'),
          text: '“ I have had a great experience, and I‘m happy with everything. I will definitely be a long term customer.”',
          title: 'By  Retailer, Vickie Johnson'
        },
        {
          img: require('@/assets/img/home/header_4.png'),
          text: '“ The items are great, and my customers are loving them”',
          title: 'By  Retailer, Southernfried'
        }
      ],
      bestSellersList: [],
      topBrandsList: [],
      storeList: [],
      brandsList: [],
      shopList: [],
      shippingFromUSAList: [],
      mostPopularBoutiqueList: [],
      mostPopularBrands: [],
      turnPages: true,
      pagination: false,
      hasTracked: false,
      timer: null
    }
  },
  created() {
    if (this.isMobile) {
      this.store = {
        slidesPerGroup: 4,
        slidesPerColumn: 2,
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false
      }
      this.bestStore = {
        slidesPerGroup: 4,
        slidesPerColumn: 2,
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false
      }
      this.turnPages = false
      this.pagination = true
    }
    this.bestSellers()
    this.loadConfigData()

    if (this.login) {
      initWebSocket()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        let reviews = this.$refs.reviews
        if (reviews) {
          let rect = reviews.getBoundingClientRect()
          if (rect.top >= 0 && rect.bottom <= window.innerHeight && !this.hasTracked) {
            // 调用 mixpanel 埋点
            mixpanel.track('Home-exposure-CUSTOMER REVIEWS')
            this.hasTracked = true
          } else {
            this.hasTracked = false
          }
        }
      }, 100)
    },
    async bestSellers() {
      const bestSellerParams = {
        collectionId: 'f9bcaa90-bb92-404c-8b51-8d9bbb20416d',
        pageNo: 1,
        pageSize: 8,
        sortValue: 1
      }
      if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
        bestSellerParams.collectionId = 'b689c5a7-9383-4539-82e0-3d5c82c9679a'
      }
      let res = await postAction('/es/searchGoods', bestSellerParams)
      let arr = []
      res.result.records.map((item) => {
        arr.push({
          ...item,
          ...{
            title: item.title,
            img: item.imgUrl,
            stockNum: item.stockNum || 0,
            totalSales: item.importCount || 0,
            netPrice: item.rrp,
            price: item.wsp
          }
        })
      })
      this.bestSellersList = arr
    },

    open(url) {
      this.$router.push({
        path: url
      })
    },
    showLoginHandle() {
      this.$emit('showLoginUp')
    },
    async loadConfigData() {
      let res = await getAction('/v0.2/market-config/home-config')
      // 1-BeautyStore 2-TopBrands 3-ShopCategories 4NewBrands
      let arr = res.result
      this.storeList = arr.filter((f) => f.type == 1)
      this.topBrandsList = arr.filter((f) => f.type == 2)
      this.shippingFromUSAList = arr.filter((f) => f.type == 5)
      this.mostPopularBoutiqueList = arr.filter((f) => f.type == 6)
      this.shopList = arr.filter((f) => f.type == 3)
      this.brandsList = arr.filter((f) => f.type == 4)
      this.mostPopularBrands = arr.filter((f) => f.type == 7)
    }
  },
  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    }
  }
}
</script>
<style src="@/swiper.css"></style>
<style lang="less" scoped>
/deep/.card-list .card5 {
  width: auto !important;
}
/deep/.swiper-slide {
  cursor: pointer;
}
.home-shopvidi-img {
  // height: 440px;
}
.home {
  font-family: Satoshi;
  min-width: 1400px;
  color: #262613;
}
.home-header {
  height: 179px;
}
.banner-content {
  width: 100%;
  height: 470px;
  position: relative;
  color: #ffffff;
  .banner-content-img {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .banner-content-text {
    position: absolute;
    width: 900px;
    top: 116px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    .banner-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
    }
    .banner-subtitle {
      font-size: 60px;
      font-family: Satoshi;
      font-weight: 500;
      line-height: 104px;
    }
    .banner-ins {
      font-weight: 500;
      width: 500px;
      margin: 0 auto;
      text-align: center;
      font-size: 23px;
      line-height: 20px;
      color: #ffffff;
    }
    .banner-button {
      width: 213px;
      height: 50px;
      cursor: pointer;
      background: #ffffff;
      opacity: 1;
      border-radius: 3px;
      margin: 0 auto;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      line-height: 50px;
      color: #262b2f;
      margin-top: 30px;
    }
  }
}

.home-list {
  width: 100%;
  height: 340px;
  background: #e1e2bf;
  display: flex;
  align-items: center;
  .home-list-w {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .list-w-content {
      width: 280px;
      text-align: center;
      .w-img {
        width: 47px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .w-title {
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        padding: 20px 0;
      }
      .w-ins {
        font-size: 14px;
        line-height: 20px;
        .w-ins-underline {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}
.home-store {
  text-align: center;
  .home-store-swiper {
    width: 1380px;
    padding: 0 20px;
    margin: 0 auto;
  }
}
.home-title {
  padding: 70px 0 30px 0;
  font-size: 40px;
}
.store-swiper-list {
  height: 436px;
  position: relative;
  .store-swiper-img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .store-swiper-text {
    height: 30px;
    font-size: 24px;
    color: #ffffff;
    font-family: Satoshi-Medium;
    text-decoration: underline;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
.new-brands {
  text-align: center;
  position: relative;
  .brands-swiper {
    width: 1380px;
    padding: 0 20px;
    margin: 0 auto;
  }
}
.brands-swiper-list {
  text-align: center;
  .brands-swiper-img {
    height: 318px;
  }
  .brands-swiper-text {
    font-family: Satoshi-Medium;
    padding-top: 10px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.home-shopvidi {
  position: relative;
  margin-top: 70px;
  width: 100%;
  // height: 440px;
  .home-shopvidi-text {
    position: absolute;
    width: 1380px;
    height: 150px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    div:nth-child(1) {
      font-size: 24px;
      font-family: Satoshi-Bold;
      line-height: 71px;
    }
    div:nth-child(2) {
      width: 409px;
      font-size: 14px;
      line-height: 24px;
      padding: 20px 0;
    }
    div:nth-child(3) {
      font-family: Satoshi;
      font-weight: 400;
      text-decoration: underline;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.home-collapse {
  margin-top: 70px;
  width: 100%;
  height: 714px;
  background: rgba(225, 226, 191, 0.39);
  .home-collapse-content {
    width: 1380px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .home-collapse-text {
      max-width: 490px;
      font-size: 16px;
      padding-top: 128px;
      div:nth-child(1) {
        max-width: 100%;
        font-size: 40px;
        font-family: Satoshi-Medium;
        padding-bottom: 57px;
      }
      div:nth-child(2) {
        max-width: 100%;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 1px;
      }
      div:nth-child(3) {
        padding-top: 30px;
        text-decoration: underline;
      }
    }
    .home-collapse-components {
      width: 624px;
      padding-top: 63px;
      .collapse-components-title {
        font-size: 24px;
        font-family: Satoshi-Medium;
        padding-bottom: 28px;
        border-bottom: 1px solid #262613;
      }
    }
  }
}
.home-reviews {
  width: 100%;
  height: 488px;
  overflow-x: hidden;
  background-color: #FFFFFF;
  opacity: 1;
  .goods-comments-area {
    width: auto;
    height: 50px;
    font-size: 40px;
    font-family: Satoshi;
    font-weight: 500;
    line-height: 50px;
    text-align: center;
    color: #262613;
    opacity: 1;
    margin: 0;
    margin-top: 70px;
    margin-bottom: 40px;
  }
}
.home-bottom {
  margin-top: 77px;
}
.bottom-swiper-list {
  width: 700px;
  margin: 0 auto;
  text-align: center;
  div:nth-child(1) {
    width: 117px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  div:nth-child(2) {
    text-align: center;
    padding: 20px 0;
  }
  div:nth-child(3) {
    font-size: 16px;
    font-weight: 500;
    font-family: Graphik;
    padding-bottom: 30px;
  }
}
.store-swiper-text {
  cursor: pointer;
}
.shop {
  .store-swiper-list {
    height: 319px;
  }
}
.m-shopvidi {
  display: none;
}
.pc-shopvidi {
  display: block;
}
.pc-banner {
  display: block;
}
.m-banner {
  display: none;
}

.vilocal-zone-main1 {
  height: 23vw;
  width: 100%;
  background: url('https://master-shopvidi.s3.amazonaws.com/index_images/index_vilocal_banner.jpg') no-repeat;
  background-size: 100% 100%;
  // position:relative;
  display: flex;
  align-items: flex-end;
  position: relative;
  margin: 70px 0 30px;
}

.vilocal-zone-main1-pc-float-banner {
  position: absolute;
  right: 30%;
  top: 210px;
  z-index: 11;
  width: 20%;
}

.vilocal-zone-main1-pc-rules {
  width: 111px;
  height: 49px;
  //margin-left: 14.7%;
  cursor: pointer;
}

.vilocal-zone-main1-m-rules {
  display: none;
}
.banner{
  margin-left:15%;
  display: flex;
  height:100%;
  flex-direction: column;
  justify-content: space-between;
}
.banner-btn{
  height:3vw;
  width:262px;
  background-color: #262613;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-family: Satoshi-Medium;
  color: #FFFFFF;
  position: relative;
  margin-top: 15.5vw;
  cursor: pointer;
}

@media screen and(max-width:750px) {
  .home-title {
    font-size: 24px !important;
  }
  .home-collapse-text {
    padding-top: 60px !important;
    div:nth-child(1) {
      font-size: 32px !important;
    }
  }
  .pc-banner {
    display: none;
  }
  .m-banner {
    display: block;
  }
  .m-shopvidi {
    display: block;
  }
  .pc-shopvidi {
    display: none;
  }
  .shop {
    .store-swiper-list {
      height: 167px !important;
    }
  }
  .home-title {
    font-size: 20px;
    font-family: Satoshi-Medium;
    padding: 30px 0 20px 0;
  }
  .home {
    font-family: Satoshi;
    min-width: 100%;
    max-width: 100%;
  }
  .home-header {
    height: 83px;
  }
  .banner-content {
    width: 100%;
    height: 300px;
  }
  .banner-content-text {
    width: 339px !important;
    top: 78px !important;
    .banner-title {
      font-size: 14px !important;
    }
    .banner-subtitle {
      width: 100% !important;
      font-size: 24px !important;
      font-weight: 500 !important;
      line-height: 43px !important;
    }
    .banner-ins {
      width: 345px !important;
      font-size: 14px !important;
      line-height: 18px !important;
    }
  }
  .home-list {
    padding-top: 40px;
    height: auto !important;
  }
  .home-list-w {
    width: 100% !important;
    flex-wrap: wrap;
  }
  .list-w-content {
    margin: 0 auto;
    padding-bottom: 40px;
  }
  .home-store-swiper {
    width: 100% !important;
    box-sizing: border-box;
    padding: 0 17px;
  }
  .store-swiper-list {
    height: 229px !important;
  }
  .brands-swiper {
    width: 100% !important;
    box-sizing: border-box;
    padding: 0 17px;
    .brands-swiper-img {
      height: 167px !important;
    }
  }
  .home-shopvidi {
    width: 100% !important;
    height: auto !important;
  }
  .home-shopvidi-img {
    width: 100%;
    height: 203px !important;
  }
  .home-shopvidi-text {
    width: 309px !important;
    left: 17px !important;
    top: 25px !important;
    margin-left: 0px !important;
    div:nth-child(1) {
      padding-bottom: 10px;
      width: 100% !important;
      line-height: 40px !important;
    }
    div:nth-child(2) {
      width: 100% !important;
      padding: 0 0 20px 0 !important;
      line-height: 18px !important;
    }
  }
  .home-collapse {
    width: 100% !important;
    padding-left: 10px;
    box-sizing: border-box;
    margin-top: 30px !important;
    height: auto !important;
    padding-bottom: 40px;
    .home-collapse-content {
      width: 100%;
      flex-wrap: wrap;
    }
  }
  .home-bottom {
    width: 100% !important;
    .bottom-swiper-list {
      width: 100% !important;
      box-sizing: border-box;
      padding: 0 15px;
    }
  }
}
@media screen and (max-width: 600px) {
  .home-reviews {
    height: 443px !important;
    .goods-comments-area {
      font-size: 20px !important;
      height: 25px !important;
      line-height: 20px !important;
      margin-top: 60px !important;
      margin-bottom: 47px !important;
    }
  }

  .vilocal-zone-main1 {
    height: 195px;
    width: 100%;
    background: url('https://master-shopvidi.s3.amazonaws.com/index_images/home_vilocal_bg.jpg') no-repeat;
    background-size: 100% 100%;
    align-items: flex-start;
    margin: 30px 0 20px;

  }

  .vilocal-zone-main1-m-rules {
    display: initial;
    width: 53px;
    height: 23px;
    margin-left: 62%;
    cursor: pointer;
  }

  .banner-btn-m{
    position: absolute;
    top: 120px;
    left: 10px;
    width: 160px;
    height: 32px;
    background-color: #262613;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Satoshi-Medium;
    font-size: 12px;
    cursor: pointer;
  }

  .vilocal-zone-main1-pc-rules {
    display: none;
  }

  .vilocal-zone-main1-m-rules {
    display: initial;
    width: 53px;
    height: 23px;
    margin-left: 62%;
    cursor: pointer;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue